import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { activeNote, startDelete } from '../../actions/notes'
import { useForm } from '../../hooks/useForm'
import NoteAppBar from './NoteAppBar'

const NoteScreen = () => {

    const dispatch = useDispatch()

    const { active: note } = useSelector(state => state.notes)

    const [formValues, handleInputChange, reset] = useForm(note)

    const { id, title, body } = formValues

    useEffect(() => {
        dispatch(activeNote(id, { ...formValues }))

    }, [ formValues, dispatch ])
    

    if (note.id !== id) {
        reset(note)
    }

    const handleDelete = () => {
        dispatch(startDelete(id))
    }

    return (
        <div className='notes__main-content'>
            <NoteAppBar />

            <div className="notes__content">
                <input
                    name="title"
                    type="text"
                    placeholder='Some awesome title'
                    className='notes__title-input'
                    value={title}
                    onChange={handleInputChange}
                />

                <textarea
                    name="body"
                    placeholder='What happened today?'
                    className='notes__textarea'
                    value={body}
                    onChange={handleInputChange}
                >
                </textarea>

                {( note.url ) &&
                    <div className="notes__image">
                        <img
                            src={`${ note.url }`}
                            alt="image"
                        />
                    </div>
                }
            </div>

            <button 
                className='btn btn-danger'
                onClick={ handleDelete }
            >
                Delete
            </button>
        </div>
    )
}

export default NoteScreen